import {RouteDefinition} from '../../../routes';
import {STPEditorListScreen} from './STPEditorListScreen';
import {STPEditorContentListScreen} from './STPEditorContentListScreen';
import {STPEditorContentEditScreen} from './STPEditorContentEditScreen';

export const STPEditorRoutes: RouteDefinition[] = [
    {
        name: 'STP Editör',
        routerLink: '/settings/stp-editor',
        component: STPEditorListScreen,
    },
    {
        name: 'STP Cihazı İçerik Listele',
        routerLink: '/settings/stp-editor/:id',
        component: STPEditorContentListScreen,
    },
    {
        name: 'STP Cihazı İçerik Ekle',
        routerLink: '/settings/stp-editor/:device_id/content/',
        component: STPEditorContentEditScreen,
    },
    {
        name: 'STP Cihazı İçerik Düzenle',
        routerLink: '/settings/stp-editor/:device_id/content/:id',
        component: STPEditorContentEditScreen,
    },
];
